import { createSelector } from "@reduxjs/toolkit";
import { selectGlobalOverride, selectSearchExecutionResult } from "views/logic/slices/searchExecutionSelectors";
import View from "views/logic/views/View";
import { createElasticsearchQueryString } from "views/logic/queries/Query";
export const selectRootView = (state) => state.view;
export const selectView = createSelector(selectRootView, (state) => state.view);
export const selectActiveQuery = createSelector(selectRootView, (state) => state.activeQuery);
export const selectIsDirty = createSelector(selectRootView, (state) => state.isDirty);
export const selectIsNew = createSelector(selectRootView, (state) => state.isNew);
export const selectViewType = createSelector(selectView, (view) => view.type);
export const selectViewStates = createSelector(selectView, (state) => state.state);
export const selectViewState = (id) => createSelector(selectViewStates, (states) => states.get(id));
export const selectActiveViewState = createSelector(
  selectActiveQuery,
  selectViewStates,
  (activeQuery, states) => states == null ? void 0 : states.get(activeQuery)
);
export const selectSearch = createSelector(selectView, (view) => view.search);
export const selectSearchId = createSelector(selectSearch, (search) => search.id);
export const selectSearchQueries = createSelector(selectSearch, (search) => search.queries);
export const selectSearchQuery = (queryId) => createSelector(selectSearchQueries, (queries) => queries.find((q) => q.id === queryId));
export const selectCurrentQuery = createSelector(
  selectActiveQuery,
  selectSearchQueries,
  (activeQuery, queries) => queries.find((query) => query.id === activeQuery)
);
export const selectQueryById = (queryId) => createSelector(selectSearchQueries, (queries) => queries.find((query) => query.id === queryId));
export const selectWidgets = createSelector(selectActiveViewState, (viewState) => viewState.widgets);
export const selectWidget = (widgetId) => createSelector(selectWidgets, (widgets) => widgets.find((widget) => widget.id === widgetId));
export const selectTitles = createSelector(selectActiveViewState, (viewState) => viewState.titles);
const selectQueryStringFromQuery = (queryId) => createSelector(selectSearch, (search) => search.queries.find((q) => q.id === queryId).query.query_string);
const selectQueryStringFromGlobalOverride = createSelector(selectGlobalOverride, (globalOverride) => {
  var _a;
  const { query_string } = (_a = globalOverride == null ? void 0 : globalOverride.query) != null ? _a : createElasticsearchQueryString();
  return query_string;
});
export const selectQueryString = (queryId) => createSelector(
  selectViewType,
  selectQueryStringFromQuery(queryId),
  selectQueryStringFromGlobalOverride,
  (viewType, queryQueryString, globalOverrideQueryString) => viewType === View.Type.Search ? queryQueryString : globalOverrideQueryString
);
export const selectParameters = createSelector(selectSearch, (search) => search.parameters);
export const selectCurrentQueryResults = createSelector(
  selectActiveQuery,
  selectSearchExecutionResult,
  (queryId, state) => {
    var _a;
    return (_a = state == null ? void 0 : state.result) == null ? void 0 : _a.forId(queryId);
  }
);
